// extracted by mini-css-extract-plugin
export default {"wrapper":"asset-tile_wrapper__Ej5Bz","extendedData":"asset-tile_extendedData__4BwRr","opacity-transition":"asset-tile_opacity-transition__oHBaG"};